import { ColorSchemeContext } from '@context/color-scheme.context';
import { useContext } from 'react';

function usePrefersColorScheme() {
  const colorSchemeContext = useContext(ColorSchemeContext);
  if (colorSchemeContext === undefined) {
    throw new Error('No context defined for ColorSchemeContext');
  }

  return colorSchemeContext;
}

export default usePrefersColorScheme;
